<!--
  在卡片列表中展示用的只读卡片，带有装饰和学习数据
  可直接传入卡片数据，或者传入 API 的返回值
-->
<template>
  <div
    ref="padEl"
    class="flex flex-col gap-3 pad g-ld-shadow"
  >
    <div class="text-15px text-[var(--text-color-secondary)]">
      <template v-if="enableTypewriter">
        {{ _t('cardview.generating') }}
        <span class="dots"></span>
      </template>
      <template v-else>
        {{
          isNeverLearned
            ? _t('cardview.never_learned')
            : _t('cardview.learn_count', { count: learnCount }) +
              (isNoMastery ? _t('cardview.no_mastery') : '')
        }}
      </template>
    </div>

    <CardEssence
      :card="card"
      :enable-typewriter="enableTypewriter"
      @typewriter-complete="onTypewriterComplete"
    />
    <ProgressBar
      v-if="!isNoMastery"
      :percent="mastery!"
      :color="
        mastery == 100
          ? `linear-gradient(90.73deg, var(--ld-premium-300) -0.17%, var(--ld-premium-400) 99.85%)`
          : undefined
      "
      :lottie="false"
      :highlight="false"
      class="h-4px!"
    />
  </div>
</template>
<script setup lang="ts">
import type { CardResponse } from '@/api/package-source'

import { type Card } from '@/types/core'
import { computed, ref } from 'vue'
import CardEssence from '@/components/CardEssence/CardEssence.vue'
import ProgressBar from '@/components/ProgressBar.vue'

const props = defineProps<{
  /** API 直接返回的数据，与 card 二选一，优先使用这个 */
  cardResponse?: CardResponse
  /** 字符串格式的卡片 json 数据，与 cardResponse 二选一，优先使用 cardResponse */
  card?: string
  /** 是否启用打字机效果 */
  enableTypewriter?: boolean
  /** 学习次数 */
  learnCount?: number
  mastery?: number
}>()

const emit = defineEmits<{
  /** 打字机效果结束 */
  (e: 'typewriter-complete'): void
}>()
const padEl = ref<HTMLDivElement>()

const card = computed(() => {
  if (props.cardResponse) {
    return JSON.parse(props.cardResponse.content) as Card
  }
  if (props.card) {
    return JSON.parse(props.card) as Card
  }

  return {} as Card
})

const isNeverLearned = computed(
  () => props.learnCount == null || props.learnCount === 0
)

const isNoMastery = computed(() => props.mastery == null || props.mastery == 0)

function onTypewriterComplete() {
  emit('typewriter-complete')
}
</script>
<style scoped>
.pad {
  border-radius: 8px;
  width: 100%;
  min-height: 44px;
  padding: 12px 16px;
  border: 1px solid var(--ld-border);
  transition: all 0.3s;
  background-color: white;
}

.dots::after {
  content: '';
  animation: dots 1.5s infinite steps(4);
}

@keyframes dots {
  0% {
    content: '';
  }
  25% {
    content: '.';
  }
  50% {
    content: '..';
  }
  75% {
    content: '...';
  }
  100% {
    content: '';
  }
}
</style>
